import { TemplateItem } from "types/";
import { generateAvatarMask } from "../../mapTemplateStateToServerTemplate";
import { AvatarShape } from "../../../types";

export const generateAvatarGraphics = (
  presenterShape: AvatarShape
): TemplateItem["graphics"] => {
  return {
    type: "Avatar",
    mask: generateAvatarMask(presenterShape),
  };
};
